import React from 'react';

import { Typography } from '@mui/material';
import { Apollo } from 'src/gql/generated';
import { makeStyles } from 'tss-react/mui';

import { formatDay } from './task-review-helpers';
import { TaskStatusBadge } from './TaskStatusPill';

type StatusRowTask = Pick<Apollo.TaskReviewFieldsFragment, 'status'> & {
  completedAt: string | null;
  startedAt: string | null;
};

const useStyles = makeStyles()(theme => ({
  detail: {
    color: theme.appColors.iconsType,
    fontSize: 12,
    lineHeight: '16px',
  },
  root: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    minHeight: 24,
  },
}));

/** The task's status under its title, with when it started or finished. Internal only. */
export const TaskStatusRow = React.memo(function TaskStatusRow({ task }: { task: StatusRowTask }) {
  const { classes } = useStyles();
  if (task.status === Apollo.TaskStatus.Template) return null;

  const detail = getDetail(task);
  return (
    <div className={classes.root}>
      <TaskStatusBadge status={task.status} />
      {Boolean(detail) && <Typography className={classes.detail}>{detail}</Typography>}
    </div>
  );
});

function getDetail(task: StatusRowTask): string | null {
  if (task.completedAt) return `Completed ${formatDay(task.completedAt)}`;
  if (task.startedAt && task.status !== Apollo.TaskStatus.Rejected)
    return `Started ${formatDay(task.startedAt)}`;
  return null;
}
